
/**
 * 2017-07 || 2019-04
 * Used on detail page
 * Add variable km/price combinations (Sixt & Hertz Mixed)
 * 
 */

import { langDict } from "./dict";
import { reservaD } from "./variables";
import { beautifyPrice, dId, dQS, logger } from "./utils";
import { drawPresupuestoBox, showPrice } from "./result_price";
import { IVA } from "./variables";
import { redrawDivs } from "./result_render";
import { drawPaymentBreakdownBox } from "./result_price";

declare var URL_BASE: string; 

function variable_km(cuota: number, chgow: number, rates: [], proveedor: number) {

  if (typeof rates == "undefined" || rates.length <= 1) {
    return ("");
  }

  let km_opt = "0.00";
  let kminc_full = 0;

  let finalPrice = "";

  for (let i=0; i<rates.length; i++) {

    let selKM = rates[i];

    kminc_full = Math.floor(parseFloat(selKM[3]) * parseInt(reservaD[5]) / 100) * 100;

    // Sixt MAX KM per reserva  if over max reserva KM:
    if (proveedor == 25) {
      kminc_full = parseInt(selKM[9]);
    }


    km_opt = beautifyPrice(parseFloat(selKM[4]) * reservaD[5] * (1 + IVA) + chgow);
    finalPrice += "<option value='" + selKM[3] + "' >" + kminc_full + " km total: " + km_opt + "</option>";

  }

  finalPrice = `<label for="km_alt">${langDict[106]}:</label>
                <div class="input-wrap">
                  <img src="${URL_BASE}img/gauge.svg" alt="" class="icon-input">
                  <select id='km_alt' name='km_alt'>
                  <option value='0' selected>${langDict[107]}</option>
                  ${finalPrice}
                  </select>
                </div>`;

  return finalPrice;

}



function selKmAlt(rates: []) {

  const kms = (<HTMLSelectElement>dId("km_alt")).value;

  let no_match = true;
  for (let i=0; i<rates.length; i++) {

    let ra = rates[i];

    if (ra[3] == kms) {
      
      logger("Matched KM: " + ra[3], "log");
      let no_match = false;

      reservaD[26] = ra[4];
      reservaD[28] = ra[6];
     
      reservaD[80] = ra[7];
      reservaD[25] = parseInt(ra[3]) * reservaD[5]; // Hertz sends on 3 per day price

      // Sixt floor total KM to max:
      if (reservaD[21] == "25") {

        // value only passed as total on sixt - gets overwritten anyway in following lines
        reservaD[25] = ra[9];
        /*
        if (ra[3] >= 500 && reservaD[25] > 6e3) {
          reservaD[25] = 6e3;
        }
      	
        if (ra[3] < 500 && reservaD[25] > 4e3) {
          reservaD[25] = 4e3;
        }
        */
      }

      // avoid odd numbers on the 1000s (Hertz):
      if (reservaD[21] == "18" && reservaD[25] >= 4000) {
        reservaD[25] = Math.floor(reservaD[25] / 100) * 100;
      }

     break;

    }

  }

  // This will block reservation - but should be done another way.
  if (no_match) {
    logger("No match for KM: " + kms, "error");
    reservaD[52] = "KO";  // ! This is in the wrong place - should be in checkTimetable??
  } else {
    reservaD[52] = "OK";
  }
  
  showPrice();
  drawPresupuestoBox();
  drawPaymentBreakdownBox("yes");

}


export { variable_km, selKmAlt };